<template>
  <div class="homePageContainer" >
    <el-container direction="vertical" style="width: 100%; height: 100%">
      <el-header
        class="headerContainer"
        :class="isStyleApplied?'headerContainer_eyeshield':''"
        style="
          width: 100%;
          height: 80px;
          padding: 0px;
          margin: 0px;
          /* background: rgba(0, 131, 253, 0.1); */
        "
      >
        <div class="leftTitleContainer">

          <div class="left-container">低空智能管控系统</div>
        </div>
        <div class="mediumMenuContainer">
          <!-- <div style="width: 110px; float:right;margin-top:20px">
            <img
              class="heartbeat"
              src="../../assets/img/home/heartbeat.gif"
              alt=""
            />
          </div> -->
          <el-menu
            :default-active="selectParentMenuIndex"
            class="homePageMainMenu"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              class="menu-item"
              v-for="(menu, index) in menuList"
              :key="index"
              :index="menu.path"
            >
              <template v-if="menu.path === 'adminHome'">
                <div class="menuNameWrap">
                        <div class="menuName">{{ menu.name}}</div>
                        <div class="menueNmeE">{{ menu.englishName }}</div>
                    </div>
              </template>
              <template v-else>
                <el-dropdown  placement="bottom" @command="handledataCommand">
                  <span>
                    <div class="menuNameWrap">
                        <div class="menuName">{{ menu.name}}</div>
                        <div class="menueNmeE">{{ menu.englishName }}</div>
                    </div>
                    <i class="el-icon-arrow-down el-icon--right arrow "></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" :class="isStyleApplied?'dropMenu_eyeshield':'dropMenu'" >
                    <el-dropdown-item
                      v-for="subMenu in menu.children"
                      :command="subMenu.path"
                      :key="subMenu.id"
                      :index="subMenu.path"
                    >
                      <span  @click="changeMenu(subMenu.path)">
                        <div class="submenuNameWrap">
                        <div class="submenuName">{{ subMenu.name}}</div>
                        <div class="submenueNmeE">{{ subMenu.englishName }}</div>
                    </div>
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="rightContainer">

          <div style="width: 110px;margin-top:30px">
            <img
              v-show="!isStyleApplied"
              class="heartbeat"
              src="../../assets/img/home/heartbeat.gif"
              alt=""
            />
          </div>

          <div class="rightTimeContainer">
            <div class="time">   {{ timeInfo.currentTime }}</div>
            <div class="dateInfo">
              <div class="date">{{ timeInfo.date }}</div>
              <div class="weekday">{{ timeInfo.weekday }}</div>
            </div>
          </div>

          <!-- 退出 -->
          <div class="rightLogoutContainer" >
            <div v-show="uBtnPermissionList.includes('eyeshieldBtn')" :class="isStyleApplied?'eyeshieldModel':'ordinaryModel'" @click="changeTheme">
              <!-- <div class="logoutTxt">退出</div> -->
            </div>
            <div  class="logoutIcon" @click="handleLogout">
              <!-- <div class="logoutTxt">退出</div> -->
            </div>
          </div>
        </div>
      </el-header>
      <el-main
        style="height: calc(100% - 80px); width: 100%;overflow: hidden"
        class="mainContainer"
      >
        <DemandReport
          v-if="selectMenuIndex === 'demandReport'"
          :userInfo="userInfo"
          @getMenuList="getMenuList"
          :menuId="menuIdList.demandReport"
          ref="demandReport"
        ></DemandReport>
        <!-- 添加三维地图iframe -->
<!--        <iframe
          v-else-if="selectMenuIndex === '3dMap'"
          src="../../../static/LacmisNJ/index.html"
          frameborder="0"
        ></iframe>-->
        <ThreedTaskControl
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === '3dMap'"
          :userInfo="userInfo"
          @getMenuList="getMenuList"
        ></ThreedTaskControl>
        <!--        <iframe
                  v-else-if="selectMenuIndex === 'areaspaceSynergy3d'"
                  src="../../../static/LacmisNJ/spacecontrol.html"
                  frameborder="0"
                ></iframe>-->
        <ThreedSpaceControl
          v-else-if="selectMenuIndex === 'areaspaceSynergy3d'"
          :userInfo="userInfo"
          @getMenuList="getMenuList"
        ></ThreedSpaceControl>
        <ThreedAirline
          v-else-if="selectMenuIndex === 'threedAirline'"
          :userInfo="userInfo"
          @getMenuList="getMenuList"
        ></ThreedAirline>
        <!-- <iframe
          v-else-if="selectMenuIndex === 'planeCounterCenter'"
          src="http://192.168.205.200"
          frameborder="0"
        ></iframe> -->
        <!--        <img-->
        <!--          v-else-if="selectMenuIndex === 'planeCounterCenter'"-->
        <!--          src="../../assets/img/home/defense.png"-->
        <!--          style="width: 100%"-->
        <!--        />-->

        <!-- <div
          class="digitalAirspace"
          v-else-if="selectMenuIndex === 'digitalAirspace'"
          src="../../assets/img/home/digitalSpace.png"
          style="width: 100%;"
        ></div> -->
        <iframe
          v-else-if="selectMenuIndex === 'digitalAirspace'"
          src="../../../static/LacmisNJ/da.html"
          frameborder="0"
        ></iframe>
        <!--        <div v-else-if="selectMenuIndex === 'planeCounterCenter'" id="mainIframe"></div>-->
        <iframe  v-else-if="selectMenuIndex === 'planeCounterCenter'" id="mainIframe" name="mainIframe" :src="!locationName.toString().includes('192.168.205')?'http://220.248.31.146:9603':'http://192.168.205.13:9603'" frameborder="0" scrolling="auto" ></iframe>
        <DemandApproval
          v-else-if="selectMenuIndex === 'demandApproval'"
          :userInfo="userInfo"
          @getMenuList="getMenuList"
          :menuId="menuIdList.demandApproval"
          ref="demandApproval"
        ></DemandApproval>
        <PickUp
          v-else-if="selectMenuIndex === 'pickUp'"
          :userInfo="userInfo"
          ref="pickUp"
        ></PickUp>
        <TaskPlanning
          v-else-if="selectMenuIndex === 'taskPlanning'"
          :userInfo="userInfo"
          @getMenuList="getMenuList"
          :menuId="menuIdList.taskPlanning"
          ref="taskPlanning"
        >
        </TaskPlanning>
        <EnvironmentalGuarantee
          v-else-if="selectMenuIndex === 'environmentalGuarantee'"
          :userInfo="userInfo"
          ref="environmentalGuarantee"
        ></EnvironmentalGuarantee>
        <PlanApproval
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'planApproval'"
          :userInfo="userInfo"
          ref="planApproval"
        >
        </PlanApproval>
        <PreacticalPlan
          v-else-if="selectMenuIndex === 'preacticalPlan'"
          :userInfo="userInfo"
          ref="preacticalPlan"
        >
        </PreacticalPlan>
        <PreacticalTemporaryPlan
          v-else-if="selectMenuIndex === 'preacticalTemporaryPlan'"
          :userInfo="userInfo"
          ref="preacticalTemporaryPlan"
        >
        </PreacticalTemporaryPlan>
        <StrategicPlan
          v-else-if="selectMenuIndex === 'strategicPlan'"
          :userInfo="userInfo"
          ref="strategicPlan"
        >
        </StrategicPlan>
        <DeliverGoods
          v-else-if="selectMenuIndex === 'deliverGoods'"
          :userInfo="userInfo"
          ref="deliverGoods"
        ></DeliverGoods>
        <!-- 任务评估 -->
        <MissionAssessment
          v-else-if="
            selectMenuIndex === 'missionAssessment' && !flightDetailShow
          "
          :userInfo="userInfo"
          ref="missionAssessment"
          @showFlightDetail="showFlightDetail"
        ></MissionAssessment>
        <!-- 收货 -->
        <ReceivingGoods
          v-else-if="selectMenuIndex === 'receivingGoods'"
          :userInfo="userInfo"
          ref="receivingGoods"
        ></ReceivingGoods>
        <TaskControl
          :ws="ws"
          v-else-if="selectMenuIndex === 'taskControl' && !flightDetailShow"
          :userInfo="userInfo"
          ref="taskControl"
          @update-theme="updateTheme"
          :isStyleApplied="isStyleApplied"
          @change-menu = "handledataCommand"
          @showFlightDetail="showFlightDetail"
        ></TaskControl>
        <FlightDetailMain
          v-else-if="
            (selectMenuIndex === 'taskControl' && flightDetailShow) ||
              (selectMenuIndex === 'missionAssessment' && flightDetailShow)
          "
          ref="flightDetailMainComponent"
          @showFlightDetail="showFlightDetail"
        ></FlightDetailMain>
        <DataControl
          v-else-if="selectMenuIndex === 'dataControl'"
          :userInfo="userInfo"
          ref="dataControl"
          @showFlightDetail="showFlightDetail"
        ></DataControl>
        <ApprovalManagement
         :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'approvalManagement'"
          :userInfo="userInfo"
          ref="approvalManagement"
          @showFlightDetail="showFlightDetail"
        ></ApprovalManagement>
        <!-- 菜单 -->
        <AirPoint
          v-else-if="selectMenuIndex === 'airPoint'"
          :userInfo="userInfo"
          ref="airPoint"
          @showFlightDetail="showFlightDetail"
        ></AirPoint>
        <AirLine
          v-else-if="selectMenuIndex === 'airLine'"
          :userInfo="userInfo"
          @change-menu = "handledataCommand"
          ref="airLine"
          @showFlightDetail="showFlightDetail"
        ></AirLine>
        <Report
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'flyReport'"
          :userInfo="userInfo"
          ref="flyReport"
          @showFlightDetail="showFlightDetail"
        ></Report>
        <Operator
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'operatorManagement'"
          :userInfo="userInfo"
          ref="operatorManagement"
          @showFlightDetail="showFlightDetail"
        ></Operator>
        <FlyDriver
        :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'pilotsManagement'"
          :userInfo="userInfo"
          ref="pilotsManagement"
          @showFlightDetail="showFlightDetail"
        ></FlyDriver>
        <Aircraft
        :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'aircraftManagement'"
          :userInfo="userInfo"
          ref="aircraftManagement"
          @showFlightDetail="showFlightDetail"
        ></Aircraft>
        <AirspaceManagement
          v-else-if="
            selectMenuIndex === 'areaspaceManagement' && !flightDetailShow
          "
          :ws="ws"
          @update-theme="updateTheme"
          :isStyleApplied="isStyleApplied"
          :userInfo="userInfo"
          ref="areaspaceManagement"
          @showFlightDetail="showFlightDetail"
          @backTwoMap="handlebackMap"
        ></AirspaceManagement>
        <AreaspaceSynergy
          v-else-if="
            selectMenuIndex === 'areaspaceSynergy' && !flightDetailShow
          "
          :userInfo="userInfo"
          ref="AreaspaceSynergy"
          @backTwoMap="handlebackMap"
        ></AreaspaceSynergy>
        <PopulationArea
          v-else-if="
            selectMenuIndex === 'populationArea' && !flightDetailShow
          "
          :userInfo="userInfo"
          ref="PopulationArea"
          @backTwoMap="handlebackMap"
        ></PopulationArea>
        <MunicipalLevelData
          v-else-if="
            selectMenuIndex === 'municipalLevelData' && !flightDetailShow
          "
          :ws="ws"
          @update-theme="updateTheme"
          :isStyleApplied="isStyleApplied"
          :userInfo="userInfo"
          ref="MunicipalLevelData"
          @backTwoMap="handlebackMap"
        ></MunicipalLevelData>
        <FlightDataShow
          v-else-if="selectMenuIndex === 'flightDataShow'"
          :userInfo="userInfo"
          ref="flightDataShow"
          @showFlightDetail="showFlightDetail"
        ></FlightDataShow>
        <FlightStatistics
          v-else-if="selectMenuIndex === 'flightStatistics'"
          :userInfo="userInfo"
          ref="flightStatistics"
          @showFlightDetail="showFlightDetail"
        ></FlightStatistics>
        <FlightPlayback
          @update-theme="updateTheme"
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'flightPlayback'"
          :userInfo="userInfo"
          @showFlightDetail="showFlightDetail"
          ref="flightPlayback"
        ></FlightPlayback>
        <TaskControl
          :ws="ws"
          @update-theme="updateTheme"
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'screenDashboard' && !flightDetailShow"
          :userInfo="userInfo"
          ref="taskControl"
          @showFlightDetail="showFlightDetail"
        ></TaskControl>
        <TaskControl
          :ws="ws"
          @update-theme="updateTheme"
          :isStyleApplied="isStyleApplied"
          v-else-if="selectMenuIndex === 'anchorPads' && !flightDetailShow"
          :userInfo="userInfo"
          ref="taskControl"
          @showFlightDetail="showFlightDetail"
        ></TaskControl>
        <Radar
          v-else-if="selectMenuIndex === 'radar' && !flightDetailShow"
          :userInfo="userInfo"
          ref="radar"
          @change-menu ="handledataCommand"
          @showFlightDetail="showFlightDetail"
        ></Radar>
        <Waiting v-else-if="'' !== selectMenuIndex"></Waiting>
      </el-main>
    </el-container>
    <!-- 返回主页 -->
    <div class="backHome" @click="handleBackHome">
      <el-button
        icon="el-icon-s-home"
        circle
        v-if="
          selectMenuIndex !== 'taskControl' &&
            selectMenuIndex !== 'areaspaceManagement'
        "
      ></el-button>
    </div>
  </div>
</template>

<script>
import ThreedAirline from "../home/ThreedAirline.vue"
import ThreedSpaceControl from "../home/ThreedSpaceControll"
import ThreedTaskControl from "../home/ThreedTaskControl.vue"
import PlanApproval from "../home/PlanApproval.vue";
import PreacticalPlan from "../home/PreacticalPlan.vue";
import PreacticalTemporaryPlan from "../home/PreacticalTemporaryPlan.vue";
import StrategicPlan from "../home/StrategicPlan.vue";
import DemandReport from "../home/DemandReport.vue";
import DemandApproval from "../home/DemandApproval.vue";
import PickUp from "../home/PickUp.vue";
import TaskPlanning from "../home/taskplan/TaskPlanning.vue";
import EnvironmentalGuarantee from "../home/EnvironmentalGuarantee.vue";
import DeliverGoods from "../home/DeliverGoods.vue";
import MissionAssessment from "../home/missionAssessment.vue";
import ReceivingGoods from "../home/ReceivingGoods.vue";
import TaskControl from "../home/TaskControl.vue";
import Waiting from "../home/Waiting.vue";
import FlightDetailMain from "../home/flightDetail/flightDetailMain.vue";
import DataControl from "../home/DataControl.vue";
import ApprovalManagement from "../home/ApprovalManagement.vue";
import AirPoint from "../home/AirPoint.vue";
import AirLine from "../home/AirLine.vue";
import Report from "../home/Report.vue";
import Operator from "../home/Operator.vue";
import FlyDriver from "../home/FlyDriver.vue";
import Aircraft from "../home/Aircraft.vue";
import AirspaceManagement from "../home/AirspaceManagement.vue";
import FlightDataShow from "../home/FlightDataShow.vue";
import FlightPlayback from "../home/FlightPlayback.vue";
import FlightStatistics from "../home/FlightStatistics.vue";
import AreaspaceSynergy from "../home/AreaspaceSynergy.vue";
import PopulationArea from "../home/PopulationArea.vue";
import MunicipalLevelData from "../home/MunicipalLevelData.vue";
import Radar from "../home/radar.vue";
export default {
  name: "home",
  data() {
    return {
      uBtnPermissionList: [],
      locationName:'',
      flightDetailShow: false,
      // 存储从那个页面跳到flightDetailMain页面的组件地址
      adressComeFromWhiceComponent: "",
      headHeight: 151,
      headWidht: 468,
      userInfo: {},
      menuList: [],
      isStyleApplied:false,
      //菜单
      menuIdList: {},
      selectMenuIndex: "",
      selectParentMenuIndex: "",
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      ws:null,
    };
  },
    destroyed() {
    this.ws&&this.ws.close()
    this.ws = null;
  },
  methods: {
    setRem() {
      // 设计稿宽度（1920px）
      const designWidth = 1920;
      // 设计稿对应的根元素font-size（1rem = 16px）
      const designFontSize = 1; // 改为16，与默认字体大小一致
      function setRemUnit() {
        const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
        const minWidth = 1200;
        const maxWidth = 3000;
        const actualWidth = Math.min(Math.max(clientWidth, minWidth), maxWidth);
        console.log(actualWidth,designWidth)
        // 计算当前根元素font-size
        const fontSize = (actualWidth / designWidth) * designFontSize;
        document.documentElement.style.fontSize = `${fontSize}px`;
      }

      // 初始化执行
      setRemUnit();
      window.addEventListener('resize', setRemUnit);
    },
       initWs(){
        let randomStr = JSON.parse(localStorage.getItem('userInfo')).userNo
        this.ws = new WebSocket(`ws://${location.hostname}:9600/websocket/login/${randomStr}`); //线上
        // this.ws = new WebSocket(`ws://192.168.205.102:8769/websocket/login/${randomStr}`); //内网102
        // this.ws = new WebSocket(`ws://192.168.205.105:8769/websocket/login/${randomStr}`); //内网105
        // this.ws = new WebSocket(`ws://220.248.31.146:9600/websocket/login/${randomStr}`); //线上上海测试
        // this.ws = new WebSocket(`ws://220.248.31.148:9600/websocket/login/${randomStr}`); //线上上海正式
        this.ws.addEventListener('open', () => {
          console.log('ws连接成功');
        });
        this.ws.addEventListener('close', (event) => {
          console.log('Websocket连接已关闭，原因：', event.code, event.reason);
          if (event.code === 1006) {
            // 判断是否未超过最大重连次数
            if (this.reconnectAttempts < this.maxReconnectAttempts) {
              // 采用指数退避策略计算重连等待时间（单位：毫秒）
              let waitTime = Math.min(128000, 2000 * Math.pow(2, this.reconnectAttempts));
              setTimeout(() => {
                console.log(`第${this.reconnectAttempts + 1}次尝试重连...`);
                this.initWs();
                this.reconnectAttempts++;
              }, waitTime);
            } else {
              console.log('已达到最大重连次数，停止重连');
            }
          }
        });
        this.ws.addEventListener('error', (err) => {
          console.log('ws连接错误', err);
        });
        this.ws.addEventListener('message', (e) => {
          let data = JSON.parse(e.data);
          //type 1 飞机详情  type 2 天气预警
          if (data.type == 3) {
          let tips = "<i class='el-icon-warn-tip'></i>" + 'data.content';
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });

        }
        })
    },
    //切换地图主题
    changeTheme(){
          const tileImages = document.querySelectorAll('.leaflet-tile-pane img');
          if (this.isStyleApplied) {
            tileImages.forEach(img => {
              img.classList.remove('sepia-grayscale');
            });
          } else {
            tileImages.forEach(img => {
              img.classList.add('sepia-grayscale');
            });
          }
        this.isStyleApplied = !this.isStyleApplied;
    },
    //zoom更新加上样式
    updateTheme(){
      const tileImages = document.querySelectorAll('.leaflet-tile-pane img');
      if (this.isStyleApplied) {
        tileImages.forEach(img => {
          img.classList.add('sepia-grayscale');
        });
      }
    },
    getTopParentPath(targetPath, data) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.children) {
          for (let j = 0; j < item.children.length; j++) {
            const child = item.children[j];
            if (child.path === targetPath) {
              return item.path;
            } else if (child.children) {
              const parentPath = this.getTopParentPath(targetPath, [child]);
              if (parentPath) {
                return parentPath;
              }
            }
          }
        }
      }
      return null;
    },
    //跳转到大屏
    changeMenu(v){
      if(v === 'screenDashboard'){
        this.$router.push({path:'/index'})
      }else if(v === 'anchorPads'){
        this.$router.push({path:'/anchorPads'})
      }
      this.selectParentMenuIndex = this.getTopParentPath(v, this.menuList)
    },
    getUserDetailInfo() {
      return this.getRequest("/user-server/api/u-user/getUserDetailInfo").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          // console.log('oData-->', oData)
          this.userInfo = data;
          sessionStorage.setItem("roleId", data.roleId);
          if (this.userInfo.iconUrl) {
            this.userInfo.iconUrl = "/minio/" + this.userInfo.iconUrl;
          } else {
            this.userInfo.iconUrl = null;
          }
          let menuList = data.upermissionList;
          if (menuList && menuList.length > 0) {
            menuList.forEach(uPermission => {

              let menu = {
                id: uPermission.id,
                name: uPermission.name,
                type: uPermission.type,
                path: uPermission.path,
                children: uPermission.children,
                englishName: uPermission.englishName
              };

              if (uPermission.path === "adminHome") {
                sessionStorage.setItem("adminHomeId", uPermission.id);
              }
              this.menuList.push(menu);
              //渲染菜单去除公共权限
              this.menuList = this.menuList.filter((item) => item.path !== "publicPermissions");
              this.menuIdList[menu.path] = uPermission.id;
            });
            //存储一下用户的按钮权限以及菜单权限
            //判断是否有2d菜单权限
            let taskControlFlag = false
            //判断是否有计划菜单
            let planFlag = false
            taskControlFlag = (this.menuList.filter(v => v.path === "flightOperationControl").length) && (this.menuList.filter(v => v.path === "flightOperationControl")[0].children.filter(e => e.path === "taskControl").length)
            planFlag = (this.menuList.filter(v => v.path === "flightOperationControl").length) && (this.menuList.filter(v => v.path === "flightOperationControl")[0].children.filter(e => e.path === "taskControl").length)
            sessionStorage.setItem("uPermissionList", JSON.stringify(menuList))
            this.uBtnPermissionList = this.getPageBtnRole("publicPermissions") || [];
            if (sessionStorage.getItem("selectMenuIndex")) {
              this.selectParentMenuIndex = this.getTopParentPath(sessionStorage.getItem("selectMenuIndex"), this.menuList)
              this.selectMenuIndex = sessionStorage.getItem("selectMenuIndex") === "adminHome" ? taskControlFlag ? "taskControl" : planFlag ? 'planApproval' : sessionStorage.getItem("selectMenuIndex") : sessionStorage.getItem("selectMenuIndex");
              this.selectParentMenuIndex = this.getTopParentPath(this.selectMenuIndex, this.menuList)
              // console.log('缓存的页面', this.selectMenuIndex)
            } else {
              this.selectMenuIndex = taskControlFlag ? "taskControl" : planFlag ? 'planApproval' : this.getFirstTypeZeroPath(this.menuList);
            }
          }

        } else if (oData.code != 401) {
          // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
          // this.$confirm(tips, "提示", {
          //   confirmButtonText: "好的",
          //   customClass: "confirmClass-style",
          //   iconClass: "",
          //   dangerouslyUseHTMLString: true,
          //   confirmButtonClass: "confirm",
          //   showCancelButton: false,
          // });
        }
      });
    }, // 获取菜单列表
    getMenuList(pid, type, status, callback) {
      if (pid) {
        this.getRequest(
          "/user-server/api/u-permission/findChildrenByParentId?pid=" +
          pid +
          "&type=" +
          type +
          "&status=" +
          status
        ).then(res => {
          let oData = res.data;
          if (oData.code == 0) {
            callback(oData.data);
          } else if (oData.code != 401) {
            // callback([]);
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      }
    },
    handleSelect(key, keyPath) {
      this.selectParentMenuIndex = key; // 选中状态更新
      this.$nextTick(()=>{
        this.selectParentMenuIndex = this.getTopParentPath(this.selectMenuIndex, this.menuList)
      })
      console.log('handleSelect-key-->', key)
      // this.selectMenuIndex = key;
      // 存储selectMenuIndex 到 webStorage中，用于刷新时返回到本页面
      // sessionStorage.setItem('selectMenuIndex', key)
      if (this.adressComeFromWhiceComponent !== key) {
        // 重置flightDetailShow为false
        this.flightDetailShow = false;
      }
      if (key == "adminHome") {
        this.$router.push({ path: "/adminHome" }); //页面跳转
        sessionStorage.setItem("selectMenuIndex", key);
      }
    },
    setTime() {
      const d = new Date();
      const dStr = this.$moment(d).format("YYYY-MM-DD HH:mm:ss");
      const dStrArr = dStr.split(" ");
      this.$data.timeInfo.currentTime = dStrArr[1];
      this.$data.timeInfo.date = dStrArr[0];
      const day = d.getDay();
      const weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.$data.timeInfo.weekday = weeks[day];
    },
    showFlightDetail(data) {
      this.$data.flightDetailShow = data.show;
      this.adressComeFromWhiceComponent = data.componentName;
      //如果是显示
      if (data.show) {
        this.$nextTick(function() {
          this.$refs.flightDetailMainComponent.init(data.id);
        });
      }
    },

    // 数据下拉点击
    handledataCommand(command) {
      //跳转其他类型路由不用存储
      if(command !== 'screenDashboard'&&command !== 'anchorPads'){
        this.selectMenuIndex = command;
        // 存储selectMenuIndex 到 webStorage中，用于刷新时返回到本页面
        sessionStorage.setItem("selectMenuIndex", command);
        this.selectParentMenuIndex = this.getTopParentPath(command, this.menuList)
      }
    },

    // 退出登陆
    handleLogout() {
      let tips = "<i class='el-icon-warn-tip'></i>是否确定退出登录?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style"
      })
        .then(() => {
          this.deleteRequest("/token-server/api/logout").then(res => {
            let oData = res.data;
            if (oData.code == 0) {
              window.sessionStorage.clear();
              this.$router.push({
                path: "/login"
              });
            } else {
              let tips = "<i class='el-icon-warn-tip'></i>退出登录失败";
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false
              });
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 回到主页
    handleBackHome() {
      this.handledataCommand("taskControl");
    },
    handlebackMap(data) {
      this.handledataCommand(data);
    }
  },
  created() {
    this.locationName = location.hostname
    this.getUserDetailInfo().then(()=>this.initWs());
  },
  mounted() {
    this.setRem()
    this.setTime();
    window.timer = setInterval(this.setTime, 1000);
    console.log(this.uBtnPermissionList);

  },
  computed: {

  },
  components: {
    PreacticalPlan,
    PreacticalTemporaryPlan,
    StrategicPlan,
    ThreedAirline,
    ThreedSpaceControl,
    DemandReport,
    DemandApproval,
    PickUp,
    TaskPlanning,
    EnvironmentalGuarantee,
    PlanApproval,
    DeliverGoods,
    TaskControl,
    Waiting,
    FlightDetailMain,
    ReceivingGoods,
    MissionAssessment,
    DataControl,
    ApprovalManagement,
    AirPoint,
    AirLine,
    Report,
    Operator,
    FlyDriver,
    Aircraft,
    AirspaceManagement,
    FlightDataShow,
    FlightStatistics,
    FlightPlayback,
    AreaspaceSynergy,
    PopulationArea,
    MunicipalLevelData,
    Radar,
    ThreedTaskControl
  },
  beforeDestroy() {
    if (window.timer) {
      clearInterval(window.timer);
      window.timer = null;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/home/home.css";
</style>
<style scoped>
/* 下拉菜单 */
.dropMenu {
  border-color: #00AEFF ;
  border-width: 1px;
  background: rgba(1 ,10 ,18 ,0.88);
  box-shadow: 0px 2px 7px 0px rgba(4, 32, 55, 0.004);
  margin-top: -15px !important;
  z-index: 3000 !important;
}
 .dropMenu_eyeshield {
   border: none;
   background: rgba(1 ,10 ,18 ,0.88);
    box-shadow: 0px 2px 7px 0px rgba(4, 32, 55, 0.004);
    margin-top: -15px !important;
    z-index: 3000 !important;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  border: none !important;
}
.el-dropdown-menu__item {
  color: #fff !important;
}
@media screen and (max-width: 1920px) {
  .el-dropdown-menu__item {
    font-size: 18px !important;
  }
}
@media screen and (min-width: 2000px) {
  .el-dropdown-menu__item {
    font-size: 24px !important;
  }
}
.dropMenu  .el-dropdown-menu__item:hover {
  background: none !important;
  color: #00AEFF !important;
}
.dropMenu_eyeshield .el-dropdown-menu__item:hover {
  background: #00aeff;
}
>>>.sepia-grayscale {
  filter: sepia(30%) grayscale(90%);
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/home.vue